var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('location-header'),_c('v-card',{staticClass:"mt-2"},[_c('div',{staticClass:"headerFooterDisplay"},[_vm._v(" Your order is being placed currently. Please do not close the browser. To cancel your order please contact the restaurant directly.")])]),_c('loading-view',{staticClass:"paddingLR",attrs:{"message":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }